import React, { useState, useEffect } from "react";
import { avatarMap } from "../../data/avatarMap";
import { Link } from "react-router-dom";

const RecentAvatars = () => {
  const [avatars, setAvatars] = useState([]);

  useEffect(() => {
    setAvatars(avatarMap.slice(-5).reverse()); // Get last 5 and reverse to show newest first
  }, []);

  return (
    <div className="px-2">
      <h1 className="home-title">Recent Avatars Integrated</h1>
      
      {/* Horizontal scroll container for mobile */}
      <div className="flex md:flex-wrap overflow-x-auto md:overflow-x-visible gap-2 md:gap-4 pb-4 md:justify-center">
        {avatars.map((avatar) => (
          <div
            key={avatar.id}
            className="flex-shrink-0 w-40 md:w-48 bg-[var(--entity-bg-color)] text-[var(--font-color)] p-3 md:p-4 border-solid border-2 border-[var(--button2-bg-color)] rounded-md hover:bg-[var(--entity-hover-bg-color)]"
          >
            <img 
              src={avatar.image} 
              alt={avatar.customName} 
              className="w-full h-24 object-cover mx-auto rounded-sm"
            />
            <div className="font-bold text-sm md:text-base mt-2 truncate text-center">
              {avatar.customName}
            </div>
          </div>
        ))}
      </div>
      
      <Link to="/avatars/" className="block mt-4 text-center">
        <button className="panel-button">
          View All Avatars
        </button>
      </Link>
    </div>
  );
};

export default RecentAvatars;